import { LearnLayout } from "./Layout/LearnLayout";

export const ObjectivesLearn = () => {
  return (
    <LearnLayout videoUrl="https://www.loom.com/embed/5f5916ab2a6548d6a93d1abd81dec508?sid=cdf1c972-6bb8-4b4f-9e3e-82bbf01a72a5">
      <h3>Objectives</h3>
      <p>
        Effective objectives writing helps differentiate between objectives and
        to-dos with a single question: "What must be true to achieve our peak
        ambition?".
      </p>
      <p>
        What's important to remember is that effective objectives are not just
        tasks to check off a box. For example, “build new product" is what you
        do and not what you want to prioritise. Instead, think of effective
        objectives as critical milestones for your journey to progress. "Expand
        into the AI market" is an objective and something that must be true to
        achieve future outcomes.
      </p>
      <h4>What Is It</h4>
      <p>
        A small set of specific, measurable outcomes that must be accomplished
        within a specific timeframe.
      </p>
      <h4>How It Works</h4>
      <p>
        <p>
          1. Use the SMART framework: Specific, Measurable, Achievable,
          Relevant, Time-based.
        </p>
        <p>
          2. Focus on outcomes: Ask "What must be true?" not "What will we
          do?".{" "}
        </p>
        <p>
          3. Limit to 3-5 objectives: Ruthlessly prioritise what truly
          matters.{" "}
        </p>
        <p>
          4. Prioritise integration: Make sure each objective directly supports
          those ahead of it.
        </p>
      </p>
      <h4>The Result</h4>
      <p>
        Clarity on what success looks like at each stage of your journey. While
        your team could do countless different things, only 3-5 objectives
        determine progress towards your peak ambition.
      </p>
      <h4>How Vojomo Helps</h4>
      <p>
        Tell Vo all about your objectives. Avoid stating the things you need to
        do, follow the SMART framework, and limit your list to 5 objectives.
        Check out the video above to take a closer look at effective objective
        writing.
      </p>
    </LearnLayout>
  );
};
